export default {"src":"/_next/static/media/search-icon.4e89aff9.svg","height":24,"width":24};